import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { SliderModalProps } from './SliderModal.types';

export const openSliderModal = ({ onClose, ...data }: SliderModalProps) =>
    openPopupHelper({ popupName: popupNames.SLIDER_MODAL, data, onClose });
